// extracted by mini-css-extract-plugin
module.exports = {"link":"AuthNav_link__eRKWB","activeLink":"AuthNav_activeLink__TsbMB"};